// @flow

export default (res: Response) => {
  if (res.status >= 200 && res.status < 300) {
    return res;
  }
  return res.json().then(e => {
    throw new Error(JSON.stringify(e));
  });
};
